import Form5498Faq from './form5498Faq';

export default Form5498Faq;
